
<template>
  <div>
    <van-nav-bar
      :fixed="true"
      :title="title"
      left-arrow
      @click-left="$router.back()"
    />
    <van-cell>
      <form action="/" class="search">
        <van-search
          v-model="searchStr"
          show-action
          label=""
          placeholder="请输入客户电话"
        >
          <template #action>
            <div class="btn" @click="onRefreshStart">搜索</div>
          </template>
        </van-search>

        <!-- <van-search
        v-model="searchStr"
        show-action
        placeholder="电话/姓名"
        @cancel="onCancel"
        shape="round"
        :action-text="'清除'"
        @search="onRefreshStart"
      /> -->
      </form>
    </van-cell>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        :immediate-check="false"
        offset="200"
        v-model="loading"
        :finished="finished"
        :finished-text="dataList.length>0?'没有更多了':'没有客户数据，请先录入'"
        @load="onLoad"
      >
        <user-item
          v-for="(user, i) in dataList"
          :key="i"
          :user="user"
          @click="$emit('click', user)"
        ></user-item>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import UserItem from "./item";

export default {
  name: "commodityList",
  components: {
    UserItem,
  },

  props: ["req", "title"],

  data() {
    return {
      searchStr: "",
      //imgUrlPath: ImgUrlPath.ImgUrlPath,
      offset: 100,
      pagesize: 10,
      pagenum: 1,
      total: 0,
      dataList: [],
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      // curtime: new Date().getTime()
    };
  },
  watch: {
    // commodity(newV,oldV) {
    //   this.onRefresh();
    // }
  },
  methods: {
    inSelect(user) {
      console.log(user);
    },
    onCancel() {
      this.pagenum = 1;
      this.searchStr = "";
      this.getList();
    },
    onRefreshStart() {
      this.pagenum = 1;

      this.getList();
    },
    // 获取数据
    getList() {
      this.loading = true;
      let data = {
        paging: {
          limit: 10,
          page: this.pagenum,
        },
      };
      console.log("req", this.req);

      data.req = this.req;
      if (this.searchStr != "") {
        data.req.$or = [
          { 客户姓名: { $regex: this.searchStr } },
          { 客户电话: { $regex: this.searchStr } },
        ];
      }
      this.$request
        .customerList(data)
        .then((res) => {
          console.log(res);
          this.loading = false;
          if (res.code == 0) {
            if (this.pagenum == 1) {
              this.list = res.data.items;
            } else {
              this.list = this.list.concat(res.data.items);
            }
            this.dataList = this.list;
            this.total = res.data.total;

            if (this.dataList.length >= res.data.total) {
              this.finished = true;
            }
          }else{
            this.finished = true;
          }
        })
        .catch(() => {
          this.finished = true;
        });
    },

    onRefresh() {
      this.pagenum = 1;
      this.finished = false;

      this.getList();
      this.refreshing = false;
    },
    onLoad() {
      this.pagenum++;
      this.getList();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getList();
      // this.$store.dispatch("setCacheObjFirstLoad", false);
      // this.onRefresh()
    });
  },
};
</script>
<style scoped lang="less">
.search {
  margin-top: 46px;
}
#commodityList {
  margin-top: 10px;
  padding: 0 10px;

  .commodityBox {
    flex-wrap: wrap;
    font-size: 14px;

    .commodityContainer {
      background-color: #fff;
      margin-bottom: 10px;
      padding: 10px !important;
      border-radius: 20px;

      // box-shadow: #666 5px 5px 5px;
      .textBox {
        margin: 5px 0px 5px 0px;

        .colon {
          display: inline-block;
          margin: 0 4px;
          color: black;
        }

        .block {
          display: inline-block;
          width: 30px;
          color: #fff;
          font-size: 12px;
          text-align: center;
          background-color: #ee0a24;
        }

        .batch {
          color: green;
        }

        .batch p {
          margin: 3px;
        }
      }
    }
  }
}
</style>